import { EMPLOYEE_ERROR_MESSAGES } from '../errors/errorMessages';

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// ── Facility validators ───────────────────────────────────────────────────────

const REQUIRED_MESSAGE = 'To pole jest wymagane';

export const formatNip = (raw: string): string => {
  const digits = raw.replace(/\D/g, '').slice(0, 10);
  if (digits.length > 8) {
    return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6, 8)}-${digits.slice(8)}`;
  }
  if (digits.length > 6) {
    return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
  if (digits.length > 3) {
    return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  }
  return digits;
};

export const validateNip = (nip: string): string => {
  const digits = nip.replace(/\D/g, '');
  if (!digits) {
    return REQUIRED_MESSAGE;
  }
  if (digits.length !== 10) {
    return 'Nieprawidłowy NIP';
  }
  return '';
};

export const validateFacilityPhone = (phone: string): string => {
  const digits = phone.replace(/\D/g, '');
  if (!digits) {
    return REQUIRED_MESSAGE;
  }
  if (digits.length !== 9) {
    return 'Niepoprawny numer telefonu';
  }
  return '';
};

export const validateZip = (zip: string): string => {
  if (!zip.trim()) {
    return '';
  }
  if (!/^\d{2}-\d{3}$/.test(zip.trim())) {
    return 'Nieprawidłowy format kodu pocztowego.';
  }
  return '';
};

// ── Employee validators ───────────────────────────────────────────────────────

export const validateEmployeeName = (value: string): string =>
  value.trim() ? '' : EMPLOYEE_ERROR_MESSAGES.REQUIRED;

export const validateEmail = (email: string): string => {
  if (!email.trim()) {
    return EMPLOYEE_ERROR_MESSAGES.REQUIRED;
  }
  if (!EMAIL_REGEX.test(email.trim())) {
    return EMPLOYEE_ERROR_MESSAGES.INVALID_EMAIL;
  }
  return '';
};

export const validateEmployeePhone = (phone: string): string => {
  const digits = phone.replace(/\D/g, '');
  if (!digits) {
    return EMPLOYEE_ERROR_MESSAGES.REQUIRED;
  }
  if (digits.length !== 9) {
    return EMPLOYEE_ERROR_MESSAGES.INVALID_PHONE;
  }
  return '';
};
